import { FC } from "react";
import styled from "@emotion/styled";

const Frame = styled.div`
  padding: var(--frame-padding, 16px);
  display: grid;
  place-items: center;
  background:
    radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0.1)
    ),
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0.06),
      rgba(255, 255, 255, 0.17)
    );
  background-attachment: scroll, scroll;
  border-radius: var(--frame-border-radius, 2rem);
  corner-shape: var(--frame-corner-shape, squircle);
  @supports (corner-shape: squircle) {
    border-radius: var(--frame-border-radius, 50%);
  }
  backdrop-filter: blur(12px);
  box-shadow:
    inset 9px 9px 9px rgba(0, 0, 0, 0.015),
    inset 1px 1px 1px rgba(255, 255, 255, 0.9),
    inset -1px -1px 1px rgba(255, 255, 255, 0.6),
    inset -9px -9px 9px rgba(255, 255, 255, 0.08);

  & > svg:first-child:last-child,
  & > img:first-child:last-child {
    display: block;
  }

  position: relative;
  overflow: hidden;

  transition:
    transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  button:not([data-disabled="true"]):active > &,
  button:not([data-disabled="true"])[data-pressed="true"] > & {
    transform: scale(0.98);
    &::before {
      opacity: 1;
      transform: translateX(-30%);
    }
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      105deg,
      transparent 0%,
      transparent 20%,
      rgba(255, 255, 255, 0.4) 50%,
      transparent 80%,
      transparent 100%
    );
    border-radius: var(--frame-border-radius, 24px);
    pointer-events: none;
    opacity: 0;
    transform: translateX(-70%);
    transition:
      opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @media (pointer: fine) {
    button:hover > &::before {
      opacity: 1;
      transform: translateX(-30%);
    }
  }
`;

export interface Props {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const GlassFrame: FC<Props> = ({ children, className, style }) => {
  return (
    <Frame className={className} style={style}>
      {children}
    </Frame>
  );
};

export default GlassFrame;
